module.exports = __webpack_public_path__ + "img/logo.d7f8e6f8.png";